import { Button, Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';

export default function EmptyWallet() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('app');
  return (
    <div className="flex flex-col gap-2x items-center p-2x md:p-4x  h-full md:h-auto">
      <Icon name="wallet" size="80" className="text-gray__dark_1" />
      <p className="text-title_4 text-gray__dark_2  text-center">
        {t('noTransactionsFound')}
        <br />
      </p>
      <Button
        variant="primary"
        size="medium"
        className="w-full md:w-[343px]"
        onClick={() => dispatch(openModal('topUpModal'))}
      >
        {t('addBalanceNow')}
      </Button>
    </div>
  );
}
